import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Sarah K.',
    role: 'Business Owner',
    image: 'https://public.readdy.ai/ai/img_res/bcec1525ddabdc4f267ef4755b44101b.jpg',
    text: 'Amazing work! Highly professional and delivered exactly what I envisioned. The branding package exceeded my expectations.',
    rating: 5,
  },
  {
    name: 'Ali R.',
    role: 'Marketing Manager',
    image: 'https://readdy.ai/api/search-image?query=professional%20businessman%20portrait%20with%20friendly%20expression%20in%20modern%20workspace%20natural%20lighting%20clean%20background&width=200&height=200&seq=102&orientation=squarish',
    text: 'Creative and reliable designer. Loved the final results! The social media designs boosted our engagement significantly.',
    rating: 5,
  },
  {
    name: 'Zara T.',
    role: 'Content Creator',
    image: 'https://readdy.ai/api/search-image?query=professional%20creative%20woman%20portrait%20with%20warm%20smile%20in%20bright%20studio%20setting%20natural%20lighting%20clean%20background&width=200&height=200&seq=103&orientation=squarish',
    text: 'Delivered on time with perfect design. Will hire again! The YouTube thumbnails increased my click-through rate dramatically.',
    rating: 5,
  },
];

export default function LuxuryTestimonialsSection() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-charcoal to-deepBlue overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            Client <span className="gradient-text">Testimonials</span>
          </h2>
          <p className="text-white/70 text-lg font-body max-w-2xl mx-auto">
            100% Client Satisfaction • Average 5-Star Rating
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.1 }}
              className="glass-panel p-8 rounded-2xl glow-gold smooth-transition hover-lift"
            >
              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold text-lg"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-white/80 font-body text-sm leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden glass-panel">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-white font-display font-bold text-sm">{testimonial.name}</div>
                  <div className="text-white/60 font-body text-xs">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
